import { useUserAuth } from '~/components/Auth';

import { WGLL_BASE_URL, WGLL_DEFAULT_PATHS, WgllConfigKey } from './constants';

export const useWgllPath = (key: WgllConfigKey): string => {
  const { tempFeatureConfig = {} } = useUserAuth() || {};
  return tempFeatureConfig?.wgllConfig?.[key] || WGLL_DEFAULT_PATHS[key];
};

export const useWgllBaseUrl = (): string => {
  const { tempFeatureConfig = {} } = useUserAuth() || {};
  const baseUrl = tempFeatureConfig?.wgllConfig?.BASE_URL || WGLL_BASE_URL;
  return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
};

export const buildSrc = (baseUrl: string, path: string): string => `${baseUrl}${path}`;
